import { Header } from "@/types/VDataTable";

const vesselName: Header = {
  text: "Vessel Name & IMO",
  type: "string",
  align: "left",
  value: "name",
  class: "vesselName",
};

const hullCoating: Header = {
  text: "Hull Coating",
  type: "string",
  align: "left",
  value: "hull",
  class: "hull",
};

const lastTrendEvent: Header = {
  text: "Last Trend Event",
  type: "string",
  align: "left",
  value: "lastTrendEvent",
  class: "lastTrendEvent",
};

const change: Header = {
  text: "Change",
  type: "string",
  align: "left",
  value: "change",
  class: "change",
};

const benchmark: Header = {
  text: "Benchmark",
  type: "string",
  align: "left",
  value: "benchmark",
  class: "benchmark",
};

const deviation: Header = {
  text: "Deviation",
  type: "string",
  align: "left",
  value: "deviation",
  class: "deviation",
};

const speedChange: Header = {
  text: "Speed Change",
  type: "string",
  align: "left",
  value: "speedChange",
  class: "speedChange",
};

const fuelOilImpact: Header = {
  text: "Fuel Oil Impact",
  type: "string",
  align: "left",
  value: "foi",
  class: "foi",
};

const rpmChange: Header = {
  text: "RPM Change",
  type: "string",
  align: "left",
  value: "rpmChange",
  class: "rpmChange",
}

const sfrChange: Header = {
  text: "SFR Change",
  type: "string",
  align: "left",
  value: "sfrChange",
  class: "sfrChange",
}

export const tableHeaders: Record<string, Header[]> = {
  shipSpeed: [
    vesselName,
    hullCoating,
    lastTrendEvent,
    change,
    benchmark,
    deviation,
    speedChange,
    fuelOilImpact,
  ],
  rpm: [
    vesselName,
    lastTrendEvent,
    change,
    benchmark,
    deviation,
    rpmChange,
  ],
  sfr: [
    vesselName,
    lastTrendEvent,
    change,
    benchmark,
    deviation,
    sfrChange,
    fuelOilImpact,
  ],
};
